import { Reveal, SectionLabel, LuxBg } from "../Reveal";
import { Accordion } from "../Accordion";
import { MODULES } from "../../content";

export const Curriculum = () => (
  <section className="relative py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24" data-testid="curriculum-section">
    <LuxBg n={1} />
    <div className="max-w-4xl">
      <div className="flex flex-wrap items-end justify-between gap-4 mb-12">
        <div>
          <Reveal><SectionLabel num="004" text="THE CURRICULUM" /></Reveal>
          <Reveal delay={0.05}>
            <h2 className="serif font-black uppercase tracking-tight text-3xl md:text-5xl text-white">
              GET A SNEAK PEEK <span className="text-[#FE0000]">INTO THE WEBINAR</span>
            </h2>
          </Reveal>
        </div>
        <Reveal delay={0.1}>
          <div className="mono text-[13px] tracking-[0.3em] text-white" data-testid="curriculum-meta">
            5 MODULES · 45 MINUTES TOTAL
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <Accordion prefix="curriculum" items={MODULES.map((m) => ({ title: m.title, body: m.body }))} />
      </Reveal>
    </div>
  </section>
);
